import api from "@/services/api";

const state = {
  list: [],
};

const mutations = {
  SET_PURCHASES(state, purchases) {
    state.list = purchases;
  },
};

const actions = {
  // ================= CREATE =================
  async createPurchase(_, payload) {
    try {
      const res = await api.post("/purchases", payload);
      return res.data;
    } catch (error) {
      console.error("Error creating purchase:", error.message);
      throw error;
    }
  },

  // ================= GET ALL =================
  async getPurchases({ commit }) {
    try {
      const res = await api.get("/purchases");
      commit("SET_PURCHASES", res.data);
    } catch (error) {
      console.error("Error fetching purchases:", error.message);
      throw error;
    }
  },

  // ================= GET BY ID =================
  async getPurchaseById(_, id) {
    try {
      const res = await api.get(`/purchases/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error fetching purchase:", error.message);
      throw error;
    }
  },

  // ================= UPDATE =================
  async updatePurchase(_, payload) {
    try {
      const id = payload.id;
      const res = await api.put(`/purchases/${id}`, payload);
      return res.data;
    } catch (error) {
      console.error("Error updating purchase:", error.message);
      throw error;
    }
  },

  // ================= DELETE =================
  async deletePurchase(_, id) {
    try {
      const res = await api.delete(`/purchases/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error deleting purchase:", error.message);
      throw error;
    }
  },

  // ================= MARK AS PAID (to vendor) =================
  async markPurchaseAsPaid(_, payload) {
    try {
      const res = await api.put(`/purchases/${payload.id}/mark-paid`, payload);
      return res.data;
    } catch (error) {
      console.error("Error marking purchase as paid:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
